/* src/app/auth/components/register-confirm/register-confirm.component.scss */
form {
  width: 400px;
  max-width: 100%;
}
/*# sourceMappingURL=register-confirm.component.css.map */
